import { useCallback, useEffect, useState } from "react";

export interface MobileDrawerControl {
  open: boolean;
  show: () => void;
  close: () => void;
}

/** The sidebar as a drawer on small screens; Escape closes it. */
export function useMobileDrawer(): MobileDrawerControl {
  const [open, setOpen] = useState(false);
  const show = useCallback(() => setOpen(true), []);
  const close = useCallback(() => setOpen(false), []);

  useEffect(() => {
    if (!open) return;
    function onKey(e: KeyboardEvent): void {
      if (e.key === "Escape") close();
    }
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, close]);

  return { open, show, close };
}
